module.exports = __webpack_public_path__ + "img/no_pendencies_icon.021de155.svg";